import { useRecentPerps } from "@/providers/settings-provider";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/perpetuals/")({
  head: () => ({
    meta: [{ title: "Reactor | Perpetuals" }],
  }),
  component: PerpetualsPage,
});

function PerpetualsPage() {
  const { recentPerps } = useRecentPerps();

  if (recentPerps.length > 0) {
    return (
      <Navigate to="/perpetuals/$coin" params={{ coin: recentPerps[0] }} />
    );
  } else {
    return <Navigate to="/perpetuals/$coin" params={{ coin: "BTC" }} />;
  }
}
